"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typeChecker_1 = require("./typeChecker");
var isEmpty = function (arr) { return arr === undefined || arr === null || arr.length < 1; };
var isNotEmpty = function (arr) { return !isEmpty(arr); };
var getLast = function (arr, defaultValue) {
    if (isEmpty(arr)) {
        return defaultValue;
    }
    return arr[arr.length - 1];
};
var getFirst = function (arr, defaultValue) {
    if (isEmpty(arr)) {
        return defaultValue;
    }
    return arr[0];
};
var getDifferenceSet = function (arr1, arr2, key) {
    var map = new Map();
    var result = [];
    if (typeChecker_1.default.isObject(arr1[0])) {
        arr1.forEach(function (e) { return map.set(e[key], true); });
        arr2.forEach(function (e) {
            if (!map.get(e[key]))
                result.push(e);
        });
    }
    else {
        arr1.forEach(function (e) { return map.set(e, true); });
        arr2.forEach(function (e) {
            if (!map.get(e))
                result.push(e);
        });
    }
    return result;
};
var shuffle = function (arr) {
    return arr
        .map(function (a) { return [Math.random(), a]; })
        .sort(function (a, b) { return a[0] - b[0]; })
        .map(function (a) { return a[1]; });
};
var arrayToObject = function (arr, key) {
    if (key === void 0) { key = 'id'; }
    if (isEmpty(arr) || !typeChecker_1.default.isObject(arr[0])) {
        return {};
    }
    return arr.reduce(function (acc, obj) {
        obj[key] && (acc[obj[key]] = obj);
        return acc;
    }, {});
};
var flatten = function (arr) {
    var _a;
    return (_a = Array.prototype).concat.apply(_a, arr);
};
/*
- hasSameElements(null, null) = false

- hasSameElements([1,2], null) = false

- hasSameElements([], []) = false

- hasSameElements([1,2], []) = false

- hasSameElements([1,2], [2,1]) = true
*/
var hasSameElements = function (arr1, arr2) {
    if (isEmpty(arr1) || isEmpty(arr2))
        return false;
    if (arr1.length !== arr2.length)
        return false;
    return arr1.every(function (item1) { return arr2.includes(item1); });
};
var size = function (arr) { return (isEmpty(arr) ? 0 : arr.length); };
// working immutably
var addOrUpdate = function (targetArray, item, key) {
    if (targetArray && item) {
        var index = targetArray.findIndex(function (targetItem) {
            return key ? targetItem[key] === item[key] : targetItem === item;
        });
        return index === -1
            ? targetArray.concat([item]) : targetArray.slice(0, index).concat([item], targetArray.slice(index + 1));
    }
    return targetArray;
};
// 중복 제거
var getUniqueSet = function (array) {
    if (isEmpty(array))
        return [];
    return Array.from(new Set(array));
};
exports.ArrayUtils = {
    size: size,
    isEmpty: isEmpty,
    isNotEmpty: isNotEmpty,
    getFirst: getFirst,
    getLast: getLast,
    getDifferenceSet: getDifferenceSet,
    arrayToObject: arrayToObject,
    shuffle: shuffle,
    flatten: flatten,
    hasSameElements: hasSameElements,
    addOrUpdate: addOrUpdate,
    getUniqueSet: getUniqueSet,
};
//# sourceMappingURL=arrayUtils.js.map